import cosmos from "./cosmos";

const projectCreatorMap = {
  cosmos,
  kava: cosmos,
  terra: cosmos,
  band: cosmos,
  starname: cosmos,
  switcheo: cosmos,
  persistence: cosmos,
  sentinel: cosmos,
  osmosis: cosmos,
  certik: cosmos,
  juno: cosmos,
  comdex: cosmos,
  lum: cosmos,
  gbridge: cosmos,
  evmos: cosmos,
  agoric: cosmos,
  injective: cosmos,
  akash: cosmos,
  sifchain: cosmos,
  archway: cosmos,
  terrav2: cosmos,
  passage3d: cosmos,
  quicksilver: cosmos,
  kujira: cosmos,
  celestia: cosmos,
  dydx: cosmos,
  dymension: cosmos,
  canto: cosmos,
};

export default (projectName) => {
  let fn = projectCreatorMap[projectName];
  if ("function" === typeof fn) return fn(projectName);
  return {};
};
